/**
 * Created by jv on 2019-10-01 (14:21).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";

const CloseSvgIcon = require("!raw-loader!Images/icons/btn_plus.svg");
const LoanIcon = require("!raw-loader!Images/icons/btn_finance.svg");

require("Styles/components/business-model-dialog.scss");
require("Styles/components/loan-dialog.scss");

class LoanDialog {
  constructor(options) {
    this.dialogId = utils.generateElementId("loan-dialog-");

    this._type = options.type || "auto-loan";

    this.roundOverview = options.roundOverview;

    this.callbackContext = options.callbackContext;
    this.onCancel = options.onCancel;
    this.onRequestLoan = options.onRequestLoan;
  }

  get type() {
    return this._type;
  }

  set type(type) {
    this._type = type;
    this.renderDialogContent();
  }

  get isOpen() {
    return utils.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
  }

  create() {
    if (this._initialized !== true) {
      this.renderDialog();

      this.$dialog.appendTo("body");
      this.initialize();
    }
  }

  initialize() {
    if (this._initialized !== true) {
      this.$dialog.modal({
        backdrop: false,
        show: false
      });

      this.setUpDialogEventListeners();

      this._initialized = true;
    }
  }

  renderDialog() {
    this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" +
      "<div class='modal-dialog modal-dialog-centered business-model-dialog loan-dialog'>" +
      "<div class='modal-content'>" +
      "</div>" +
      "</div>" +
      "</div>");

    this.renderDialogContent();
  }

  renderDialogContent() {
    if (utils.isNull(this.roundOverview)) return;

    let $dialogContent = this.$dialog.find(".modal-content");

    if (utils.isNotNull($dialogContent) && $dialogContent.length) {
      $dialogContent.empty();

      log.debug("Setting up loan dialog (type: %s) - %o", this.type, this.roundOverview);

      let $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
      $closeBtn.html(CloseSvgIcon);
      $dialogContent.append($closeBtn);

      let $loanDialogContent = $("<div class='loan-dialog__content'></div>");
      let $loanDialogTop = $("<div class='loan-dialog__top'></div>");
      $loanDialogContent.append($loanDialogTop);

      let $loanDialogBottom = $("<div class='loan-dialog__bottom'></div>");
      $loanDialogContent.append($loanDialogBottom);

      $loanDialogTop.append(`<div class='loan-dialog__icon'>${LoanIcon}</div>`);

      if (this.type === "request-loan") {
        $loanDialogTop.append(`<h6 class='loan-dialog__title'>${LanguageManager.getValueForKey("serious_game.business_model.loan.dialog.request.title")}</h6>`);

        $loanDialogBottom.append(`<p>${LanguageManager.getValueForKey("serious_game.business_model.loan.dialog.request.text")}</p>`);

        let $loanDialogActions = $("<div class='loan-dialog__actions'></div>");
        $loanDialogActions.append(`<button class='btn btn-outline-c-light-blue btn-lg btn-block request-loan-btn' type='button'>${LanguageManager.getValueForKey("serious_game.business_model.loan.dialog.actions.request_loan")}</button>`);

        $loanDialogBottom.append($loanDialogActions);
      } else if (this.type === "auto-loan") {
        $loanDialogTop.append(`<h6 class='loan-dialog__title'>${LanguageManager.getValueForKey("serious_game.business_model.loan.dialog.auto.title")}</h6>`);
        $loanDialogBottom.append(`<p>${LanguageManager.getValueForKey("serious_game.business_model.loan.dialog.auto.text")}</p>`);
      } else if (this.type === "optional-loan") {
        $loanDialogTop.append(`<h6 class='loan-dialog__title'>${LanguageManager.getValueForKey("serious_game.business_model.loan.dialog.optional.title")}</h6>`);
        $loanDialogBottom.append(`<p>${LanguageManager.getValueForKey("serious_game.business_model.loan.dialog.optional.text")}</p>`);
      }

      $dialogContent.append($loanDialogContent);

      this.setUpEventListeners();
    }
  }

  setRequestLoanButtonLoading(flag) {
    let $requestLoanBtn = this.$dialog.find(".request-loan-btn");
    $requestLoanBtn.removeClass("btn-loading").prop("disabled", flag);

    if (flag) {
      $requestLoanBtn.addClass("btn-loading");
    }
  }

  show() {
    this.setRequestLoanButtonLoading(false);
    this.$dialog.modal("show");
  }

  hide() {
    this.$dialog.modal("hide");
  }

  setUpDialogEventListeners() {

  }

  setUpEventListeners() {
    this.$dialog.find(".btn").on("transitionend", (e) => {
      // transitionend fix for dialog close animations
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    this.$dialog.find(".dialog-close-btn").on("click", (e) => {
      if (utils.isFunction(this.onCancel)) {
        this.onCancel.call(this.callbackContext, this);
      }
    });

    this.$dialog.find(".request-loan-btn").on("click", (e) => {
      if (utils.isFunction(this.onRequestLoan)) {
        this.onRequestLoan.call(this.callbackContext, this);
      }
    });
  }
}

export default LoanDialog;



// WEBPACK FOOTER //
// ./app/js/components/game/components/loan-dialog.js